import { useResource } from '@landsbankinn/l16n';
import { Box, P, ShortSplitter } from '@landsbankinn/ui-kit';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { useApplicationServerContext, type LoginServerState } from 'src/state';
import { loginRes } from './Login.res';

export function LoginHeaders() {
  const [serverState] = useApplicationServerContext() as [LoginServerState];
  const { r, locale } = useResource();
  const { isMobile } = useScreenSize();
  const headerTitleRes = serverState.isConsentFlow
    ? loginRes.authenticate
    : loginRes.login;
  return (
    <Box>
      <P fontVariant="h2" fontSize={isMobile ? '44' : '56'} as="h1">
        {r(headerTitleRes)}
      </P>
      {!serverState.landsbankiClient && (
        <Box>
          <ShortSplitter height="32" />
          <P fontVariant="body" fontSize="16">
            {r(
              serverState.customScopeName === 'pis'
                ? loginRes.authenticate_description_tpp_pis
                : loginRes.authenticate_description_tpp_ais,
            ).replaceAll('{client}', serverState.clientName[locale])}
          </P>
        </Box>
      )}
    </Box>
  );
}
